import { PLATFORM_NAME } from '~/config';

interface RxLogoProps {
  size?: number;
  color?: string;
  mono?: boolean;
  /** Nome lido pelo leitor de tela; na tela de um escritório, o nome dele. */
  label?: string;
}

export function RxLogo({
  size = 36,
  color = 'currentColor',
  mono = false,
  label = PLATFORM_NAME,
}: RxLogoProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      style={{ display: 'block' }}
      role="img"
      aria-label={label}
    >
      <title>{label}</title>
      <rect
        x="1"
        y="1"
        width="38"
        height="38"
        rx="10"
        fill={mono ? 'transparent' : color}
        stroke={mono ? color : 'none'}
        strokeWidth={mono ? 1.5 : 0}
      />
      <path
        d="M13 11h7.5c3.3 0 5.8 2.1 5.8 5.2 0 2.4-1.5 4.1-3.7 4.8L27 29h-3.6l-4-7.2h-3.2V29H13V11zm6.9 8c1.6 0 2.7-1 2.7-2.6s-1.1-2.6-2.7-2.6h-3.7V19h3.7z"
        fill={mono ? color : '#fff'}
      />
      <path
        d="M24 24l4.5 5"
        stroke={mono ? color : '#fff'}
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
